import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { TooltipWrapper } from "../Tooltip/TooltipWrapper";

import ActionButton from "./ActionButton";

type Props = ComponentPropsWithoutRef<typeof ActionButton> & {
  content?: string;
};

const TooltipButton = forwardRef<HTMLButtonElement, Props>(
  ({ content, ...props }, ref) => (
    <TooltipWrapper content={content}>
      <span>
        <ActionButton ref={ref} {...props} />
      </span>
    </TooltipWrapper>
  ),
);

TooltipButton.displayName = "TooltipButton";

export default TooltipButton;
